/* odaban® Halloween-Sale: Code-Logik, Rubbel-Coupon, Countdown, Effekte, Warenkorb */
(function () {
  if (window.ohwInit) return; window.ohwInit = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function codeActive(code) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return !!(m && decodeURIComponent(m[1]).toUpperCase() === String(code).toUpperCase());
  }
  var applying = {};
  function applyCode(code) {
    if (!code || codeActive(code)) return Promise.resolve();
    if (applying[code]) return applying[code];
    applying[code] = fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .catch(function () {}).then(function () { applying[code] = null; });
    return applying[code];
  }
  window.ohwApplyCode = applyCode;

  /* ---------- Effekte ---------- */
  var BAT = '<svg viewBox="0 0 64 28" aria-hidden="true"><path d="M32 9c1.4-3 3-4 3-4l1 3c1.7-.2 3.2.4 4.3 1.6C44 6 50 4 56 6c-2 1.6-2.8 3.6-2.6 5.6 3-.8 6.4.2 8.6 2.4-3.6-.4-6.6.8-8.4 3.2-2.4-1.6-5.6-1.6-8 .4-1.6-2.6-4.6-3.6-7.6-2.8C37.4 17.8 34.8 20 32 23c-2.8-3-5.4-5.2-6-8.2-3-.8-6 .2-7.6 2.8-2.4-2-5.6-2-8-.4C8.6 14.8 5.6 13.6 2 14c2.2-2.2 5.6-3.2 8.6-2.4.2-2-.6-4-2.6-5.6 6-2 12 0 15.7 3.6 1.1-1.2 2.6-1.8 4.3-1.6l1-3s1.6 1 3 4z"/></svg>';
  function effects(root) {
    var fx = root.querySelector('.ohw-fx'); if (!fx || reduce) return;
    var n = parseInt(fx.getAttribute('data-bats') || '0', 10), base = parseInt(fx.getAttribute('data-size') || '170', 10);
    for (var i = 0; i < n; i++) {
      var b = document.createElement('span'); b.className = 'ohw-bat'; b.innerHTML = BAT;
      var top = 6 + Math.random() * 55;
      b.style.cssText = 'top:' + top + '%;--s:' + Math.round(base * (0.6 + Math.random() * 0.6)) + 'px;--d:' + (11 + Math.random() * 10) + 's;--dl:-' + (Math.random() * 14) + 's;--y0:' + (Math.random() * 40 - 20) + 'px;--y1:' + (Math.random() * 90 - 45) + 'px;opacity:' + (.6 + Math.random() * .35);
      fx.appendChild(b);
    }
  }

  /* ---------- Countdown ---------- */
  function countdown(root) {
    var end = root.getAttribute('data-end'); if (!end) return;
    var t = Date.parse(end); if (isNaN(t)) return;
    var box = root.querySelector('.ohw-timer');
    var u = box ? { d: box.querySelector('[data-u=d]'), h: box.querySelector('[data-u=h]'), m: box.querySelector('[data-u=m]'), s: box.querySelector('[data-u=s]') } : null;
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function tick() {
      var left = t - Date.now();
      if (left <= 0) {
        document.querySelectorAll('.ohw').forEach(function (s) { s.classList.add('is-ended'); });
        if (box) { box.innerHTML = '<p class="ohw-timer__label">' + (box.getAttribute('data-ended') || '') + '</p>'; }
        return;
      }
      if (u) {
        var s = Math.floor(left / 1000);
        u.d.textContent = Math.floor(s / 86400); u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        u.m.textContent = pad(Math.floor(s % 3600 / 60)); u.s.textContent = pad(s % 60);
        box.classList.toggle('is-urgent', left < 864e5);
      }
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- Rubbel-Coupon ---------- */
  function scratch(root) {
    var sc = root.querySelector('.ohw-sc'); if (!sc) return;
    var code = sc.getAttribute('data-code'), card = sc.querySelector('.ohw-sc__card'), cv = sc.querySelector('canvas');
    var done = false;
    function burst() {
      if (reduce) return;
      var b = sc.querySelector('.ohw-sc__burst'), cols = ['#ff7a1a', '#ffb070', '#f5f2ec', '#1d1915'];
      for (var i = 0; i < 26; i++) {
        var p = document.createElement('i'), a = Math.random() * Math.PI * 2, r = 70 + Math.random() * 120;
        p.style.cssText = '--x:' + Math.cos(a) * r + 'px;--y:' + Math.sin(a) * r + 'px;--r:' + (Math.random() * 540) + 'deg;--c:' + cols[i % 4];
        b.appendChild(p);
      }
      setTimeout(function () { b.innerHTML = ''; }, 1000);
    }
    function reveal(silent) {
      if (done) return; done = true; sc.classList.add('is-revealed');
      try { localStorage.setItem('ohw-rev-' + code, '1'); } catch (e) {}
      applyCode(code); if (!silent) burst();
      var live = sc.querySelector('[role=status]'); if (live) live.textContent = sc.getAttribute('data-live') || '';
    }
    var seen = false; try { seen = localStorage.getItem('ohw-rev-' + code) === '1'; } catch (e) {}
    if (codeActive(code) || seen) { reveal(true); return; }
    var alt = sc.querySelector('.ohw-sc__alt'); if (alt) alt.addEventListener('click', function () { reveal(false); });
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), w, h, drawing = false, moves = 0;
    function paint() {
      var r = card.getBoundingClientRect(); w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var g = ctx.createLinearGradient(0, 0, w, h); g.addColorStop(0, '#2a241e'); g.addColorStop(1, '#0d0b09');
      ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,122,26,.10)';
      for (var y = 10; y < h; y += 26) for (var x = (y / 26 % 2) * 13; x < w; x += 26) { ctx.beginPath(); ctx.arc(x, y, 2.2, 0, 7); ctx.fill(); }
      ctx.fillStyle = '#ff7a1a'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '800 22px Poppins, Helvetica, Arial, sans-serif'; ctx.fillText(sc.getAttribute('data-label') || '', w / 2, h / 2 - 12);
      ctx.fillStyle = '#cfc7bd'; ctx.font = '500 14px Poppins, Helvetica, Arial, sans-serif'; ctx.fillText(sc.getAttribute('data-hint') || '', w / 2, h / 2 + 18);
    }
    paint();
    window.addEventListener('resize', function () { if (!done) paint(); });
    function pos(e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    function scrape(p) {
      ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(p.x, p.y, 24, 0, 7); ctx.fill();
      if (++moves % 8 === 0) check();
    }
    function check() {
      var d = ctx.getImageData(0, 0, cv.width, cv.height).data, clear = 0, tot = 0;
      for (var i = 3; i < d.length; i += 4 * 24) { tot++; if (d[i] < 40) clear++; }
      if (clear / tot > 0.45) reveal(false);
    }
    cv.addEventListener('pointerdown', function (e) { drawing = true; cv.setPointerCapture(e.pointerId); scrape(pos(e)); });
    cv.addEventListener('pointermove', function (e) { if (drawing) scrape(pos(e)); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { cv.addEventListener(ev, function () { drawing = false; }); });
  }

  /* ---------- In den Warenkorb (mit Code) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ohw-add]'); if (!btn) return;
    e.preventDefault(); if (btn.getAttribute('aria-busy') === 'true') return;
    var code = btn.getAttribute('data-code'), err = btn.parentNode.querySelector('.ohw-err');
    btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
    var fd = new FormData(); fd.append('id', btn.getAttribute('data-ohw-add')); fd.append('quantity', '1');
    applyCode(code).then(function () {
      if (window.odabanAjaxAdd) return window.odabanAjaxAdd(fd, btn, { focus: btn });
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd }).then(function (r) {
        if (!r.ok) throw r; window.location.href = '/cart';
      });
    }).catch(function () { if (err) err.hidden = false; }).then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Hexennebel nur zeigen, solange ein Halloween-Abschnitt im Bild ist ---------- */
  function mist() {
    var m = document.querySelector('.ohw-mist'); if (!m || !('IntersectionObserver' in window)) return;
    var vis = new Set();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? vis.add(e.target) : vis.delete(e.target); });
      m.classList.toggle('is-off', vis.size === 0);
    }, { rootMargin: '0px 0px -60% 0px' });
    document.querySelectorAll('.ohw').forEach(function (s) { io.observe(s); });
  }

  function init() {
    mist();
    document.querySelectorAll('.ohw-hero').forEach(function (h) { effects(h); scratch(h); });
    document.querySelectorAll('.ohw[data-end]').forEach(function (r) { if (r.getAttribute('data-end')) countdown(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target.querySelector('.ohw-hero'); if (h) { effects(h); countdown(h); scratch(h); }
  });
})();